export default function TagUserActiveIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 1.66675H5C3.61667 1.66675 2.5 2.77508 2.5 4.14175V13.2334C2.5 14.6001 3.61667 15.7167 5 15.7167H5.63333C6.29167 15.7167 6.93333 15.9751 7.4 16.4417L8.825 17.8501C9.475 18.4917 10.525 18.4917 11.175 17.8501L12.6 16.4417C13.0667 15.9751 13.7083 15.7167 14.3667 15.7167H15C16.3833 15.7167 17.5 14.6001 17.5 13.2334V4.14175C17.5 2.77508 16.3833 1.66675 15 1.66675ZM10 4.62508C10.9 4.62508 11.625 5.35841 11.625 6.25008C11.625 7.13341 10.925 7.84175 10.0583 7.87508C10.025 7.87508 9.975 7.87508 9.93333 7.87508C9.05833 7.84175 8.36667 7.13341 8.36667 6.25008C8.375 5.35841 9.1 4.62508 10 4.62508ZM12.2917 12.2417C11.0333 13.0834 8.96667 13.0834 7.70833 12.2417C6.6 11.5084 6.6 10.2917 7.70833 9.55008C8.975 8.70842 11.0417 8.70842 12.2917 9.55008C13.4 10.2917 13.4 11.5001 12.2917 12.2417Z"
        fill="#2ED0FF"
      />
    </svg>
  );
}
